import { IconFlag, TableCellEmpty } from '@/components/custom';
import { TableCell } from '@/components/ui';
import { IHasUser } from '.';

export const DataTableBodyCellCountry = ({ user }: IHasUser) => (
  <TableCell className='py-1 pe-0 w-0'>
    {
      user.countryIso3
        ? <IconFlag
          country={user.countryIso3}
          className='mx-auto' />
        : <TableCellEmpty text='Non défini' />
    }
  </TableCell>
);

export default DataTableBodyCellCountry;
